export default {
  title: 'Închidere Disponibilitate',
  close_availabilities_form: {
    date_range: {
      label: 'Selectați o Dată și oră.',
    },
  },
  reason: {
    label: 'Adăugați un motiv (opțional)',
    placeholder: 'Introduceți descrierea...',
  },
  recurring: {
    label: 'Recurent anual',
  },
  buttons: {
    save: 'Salvați',
    cancel: 'Anulați',
    add: '+ Adăugați Excepție',
    reactivate: 'Reactivați',
  },
  reservations: {
    title: 'Rezervări',
    description: 'Doriți să adăugați excepția de program la rezervări?',
    add: 'Adăugați',
    cancel: 'Anulați',
  },
  projects: {
    online_shop: 'Magazin Online',
    reservations: 'Rezervări',
    storefront: 'Vitrină',
  },
  success_messages: {
    reservation_updated: 'Excepție de program adăugată cu succes',
  },
  error_messages: {
    date_range_required: 'Vă rugăm să selectați un interval de date.',
    creation_failed: 'Crearea excepției a eșuat',
    overlapping_schedule_exception: 'Există deja o excepție de program pentru acel interval de timp',
    merge_schedule_exceptions:
      'Următoarea excepție de program {{oldDate}} va fi îmbinată cu {{newDate}}. Puteți actualiza și intervalul de date pentru {{oldDate}}.',
  },
};
